import VueRouter from "vue-router"
import baota from '../view/baota'
import dieji from '../view/dieji'
import sushi from '../view/sushi'
import xiandai from '../view/xiandai'
import oushi from '../view/oushi'
const router = new VueRouter({
    routes: [
        //配置路由的路径
        {
            path: '/',
            component: baota
        },
        {
            path: '/dieji',
            component: dieji
        },
        {
            path: '/sushi',
            component: sushi
        },
        {
            path: '/xiandai',
            component: xiandai
        },
        {
            path: '/oushi',
            component: oushi
        }
    ]
})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js